'use client';

import React from 'react';

import { MessageIcon } from '@depop/web-ui-kit/Icons/MessageIcon';
import { VisuallyHidden } from '@depop/web-ui-kit/VisuallyHidden';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { NavigationLink } from '../NavigationLink';
import { NavigationListItem } from '../NavigationListItem';

import styles from './styles.module.css';

import { NotificationIndicator } from '@/components/NotificationIndicator';
import { useUserCounter } from '@/modules/user/useUserCounter';

export function NavigationMessagesButton() {
  const t = useTranslations('common');
  const pathname = usePathname();
  const isActive = pathname?.includes(`messages`);

  const { data } = useUserCounter();

  const hasNewMessages =
    data && (data.new_messages_count > 0 || data.buyer_offers_to_action > 0);

  return (
    <NavigationListItem>
      <NavigationLink isActive={isActive} href="/messages/">
        <div className={styles.messageIconWrapper}>
          {hasNewMessages && <NotificationIndicator />}
          <VisuallyHidden>
            {hasNewMessages ? t('Nav.NewMessage') : t('Nav.Messages')}
          </VisuallyHidden>
          <MessageIcon className={styles.messageIcon} size={28} aria-hidden />
        </div>
      </NavigationLink>
    </NavigationListItem>
  );
}
